export const GROUP_NAME = 'stepper'
